import { PupPolicy } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { Box, Stack } from '@mui/material';

import HeaderTypography from '../HeaderTypography';
import PolicyDetailsCard from '../PolicyDetailsCard';

interface PersonalUmbrellaPolicyDetailsProps {
  pupPolicy: PupPolicy;
}

const PersonalUmbrellaPolicyDetails = ({
  pupPolicy,
}: PersonalUmbrellaPolicyDetailsProps) => {
  return (
    <Box
      sx={{
        width: 1,
        px: {
          mobile: 2,
          tablet: 4,
          desktop: 7,
        },
        py: {
          mobile: 2,
          tablet: 2,
          desktop: 9,
        },
      }}
    >
      <HeaderTypography text="Personal Umbrella policy" />
      <Stack
        direction={{ mobile: 'column', desktop: 'row' }}
        spacing={3}
        sx={{
          width: 1,
          marginTop: '24px'
        }}>
        <Stack spacing={{ mobile: 2, tablet: 3 }} sx={{
          width: 1
        }}>
          <PolicyDetailsCard policy={pupPolicy} />
        </Stack>
      </Stack>
    </Box>
  );
};

export default PersonalUmbrellaPolicyDetails;
